// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"x5Tz2NUEKCitLhPwQtANt_0","tree":"_25cntyBSgkEJrL2G_wGkdp_0","tree-edit-btn":"_1YjWIqv7BP94mzxsrcFhSg_0","btn-bar":"ECc1mKK3T-GVxzeTQTWXy_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c595eb4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dashboard/components/frame/DashboardList.vue
// module id = Y05r
// module chunks = 75